import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { pathForSection } from "@/workspace/sections";

export default function StrategyRoomCTA({ t, prominent = false, testId = "strategy-room-link" }) {
  return (
    <Link to={pathForSection("strategist")} className={prominent ? "primary-button strategy-cta" : "quiet-button strategy-cta"} data-testid={testId}>
      <Sparkles size={16} />
      <span>{prominent ? t.startConversation : t.startConversationShort}</span>
    </Link>
  );
}
